var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters pb-6"},[_c('general-tags'),_vm._l((_vm.filteredGroups),function(group,index){return _c('tags-wrapper',{key:("filterGroup-" + (group.tag_group.id)),attrs:{"group":group}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }